module.exports = __webpack_public_path__ + "media/2022/student-lockup-d7122f03.jpg";